<script>
import { FormModel } from '@/components/global/form';
import { meta } from 'utils/DOM';
import { scrollToError } from '../../utilities/helpers';

// Step 7

export default {
    name: 'CcShareholdersForm',

    props: {
        initialData: null,
    },

    data() {
        return {
            loading: false,
            model: null,
            addingDocumentTo: null,
            hasUploadingDocuments: false,
        };
    },

    created() {
        this.model = new FormModel(this.initialData).transform(data => {
            data.shareholders.forEach(shareholder => {
                shareholder.documents = shareholder.documents.map(document => document.file);
            });

            return data;
        });
    },

    methods: {
        addShareholder() {
            this.model.$.shareholders.push({
                type: null,
                title: '',
                documents: [],
            });
        },

        removeShareholder(account) {
            this.model.$.shareholders = this.model.$.shareholders.filter(s => s !== account);
        },

        async submit() {
            if (this.loading && this.hasUploadingDocuments) {
                return;
            }
            this.loading = true;

            try {
                const response = await this.$http.post('', this.model.data);
                window.location = response.data.data.redirect;
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);
            }

            this.loading = false;
        },

        documentsChanged(e) {
            const relation = this.addingDocumentTo;

            if (!relation || !e.target.files.length) {
                return;
            }

            Array.from(e.target.files).forEach((file) => {
                relation.documents.push({
                    _file: file,
                    file: null,
                    uploading: false,
                    cancelToken: null,
                    error: null,
                });
            });

            e.target.value = '';

            this.uploadFiles();
        },

        addDocuments(relation) {
            this.addingDocumentTo = relation;
            const fileInput = this.$refs.documentSelect;
            fileInput.click();
        },

        removeDocument(shareholder, index) {
            const document = shareholder.documents[index];
            if (document.cancelToken) {
                document.cancelToken.abort();
                document.cancelToken = null;
            }

            shareholder.documents.splice(index, 1);
        },

        async uploadFiles() {
            for (const shareholder of this.model.$.shareholders) {
                for (const entry of shareholder.documents) {
                    if (!entry._file || entry.file || entry.uploading) {
                        continue;
                    }

                    entry.uploading = true;
                    entry.cancelToken = new AbortController();

                    const formData = new FormData();
                    formData.append('_token', meta('csrf-token'));
                    formData.append('file', entry._file);

                    fetch('/legal-entity/shareholders/documents', {
                        method: 'POST',
                        body: formData,
                        signal: entry.cancelToken.signal,
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    })
                        .then((response) => {
                            if (response.ok) {
                                return response
                                    .json()
                                    .then((data) => {
                                        entry.uploading = false;
                                        entry.cancelToken = null;
                                        entry.file = data.data.file;

                                        return data;
                                    });
                            }

                            if (response.status === 422) {
                                return response.json()
                                    .then((data) => {
                                        entry.error = data.error.errors.file.join(', ');
                                        entry.uploading = false;
                                        entry.cancelToken = null;

                                        return data;
                                    });
                            }

                            // Not sure about use cases here, so just report error
                            entry.error = 'Įvyko klaida įkeliant dokumentą';
                            entry.uploading = false;
                            entry.cancelToken = null;

                            return null;
                        })
                        .catch((error) => {
                            if (error.name === 'AbortError') {
                                const index = shareholder.documents.indexOf(entry);

                                if (index !== -1) {
                                    this.removeDocument(shareholder, index);
                                }

                                return;
                            }

                            entry.uploading = false;
                            entry.cancelToken = null;

                            this.$sentyReporting.report(error);
                        });
                }
            }
        },
    },
};
</script>
